import { UntypedFormControl } from '@angular/forms';

export default function customPatternValidator(pattern: RegExp, validationKey: string, inverseMatch: boolean = false) {
    return (formControl: UntypedFormControl) => {
        if (!formControl.parent) {
            return null;
        }
        if (inverseMatch) {
            if (pattern.test(formControl.value)) {
                return {[validationKey]: true};
            }
        } else {
            if (!pattern.test(formControl.value)) {
                return {[validationKey]: true};
            }
        }

        return null;
    };
}
